// extracted by mini-css-extract-plugin
export default {"form-container":"LandingPage1Form_form-container__aSoIf","form":"LandingPage1Form_form__gNJ51"};